import { SimpleMenu } from "@components";
import { useTranslation } from "react-i18next";

const MenuSocial = function ({ active }) {
  const { t } = useTranslation();

  return (
    <SimpleMenu
      title={t("social_responsibility")}
      active={active}
      menu={[
        {
          text: t("KebijakanTanggungJawab"),
          link: "/csr-policy",
        },
        {
          text: t("PelaksanaanTanggungJawab"),
          link: "/csr-activity",
        },
      ]}
    />
  );
};
export default MenuSocial;
